import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Delete, Edit, MoreVert, Visibility } from '@mui/icons-material';
import { Menu, MenuItem } from '@mui/material';

const ActionsPopover = ({
  editTitle,
  deleteTitle,
  viewTitle,
  onEditClick,
  onDeleteClick,
  onViewClick,
}) => {
  const [anchorEl] = useState(null);
  const popoverOpen = Boolean(anchorEl);
  const id = popoverOpen ? 'simple-popover' : undefined;

  const [menu, setMenu] = useState(null);
  const openMenu = ({ currentTarget }) => setMenu(currentTarget);
  const closeMenu = () => setMenu(null);

  return (
    <div>
      <MoreVert
        aria-describedby={id}
        variant="contained"
        onClick={openMenu}
        style={{ cursor: 'pointer' }}
      />
      <Menu
        id="simple-menu"
        anchorEl={menu}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(menu)}
        onClose={closeMenu}
      >
        {viewTitle?.length > 0 && (
          <MenuItem
            key={'view'}
            onClick={() => {
              onViewClick();
              closeMenu();
            }}
          >
            <Visibility color="info" style={{ marginRight: '4px' }} />{' '}
            {viewTitle}
          </MenuItem>
        )}
        {editTitle && (
          <MenuItem
            key={'edit'}
            onClick={() => {
              onEditClick();
              closeMenu();
            }}
          >
            <Edit style={{ marginRight: '4px' }} /> {editTitle}
          </MenuItem>
        )}
        {deleteTitle && (
          <MenuItem
            key={'delete'}
            onClick={() => {
              onDeleteClick();
              closeMenu();
            }}
          >
            <Delete color="error" style={{ marginRight: '4px' }} />{' '}
            {deleteTitle}
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};

ActionsPopover.propTypes = {
  editTitle: PropTypes.string,
  deleteTitle: PropTypes.string,
  viewTitle: PropTypes.string,
  onEditClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  onViewClick: PropTypes.func,
};

ActionsPopover.defaultProps = {
  editTitle: '',
  deleteTitle: '',
  viewTitle: '',
  onEditClick: () => {},
  onDeleteClick: () => {},
  onViewClick: () => {},
};

export default ActionsPopover;
